import "./App.css";
import React from "react";
import { Route, Routes } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import "./App.css";
import Admin from "./admin";
import Register from "./register";
import Homepage from "./homepage";

function App() {

    return (
        <div className="App">
            <Routes>
                <Route path="/" element={<Homepage />} />
                <Route path="/admin" element={<Admin />} />
                <Route path="/register" element={<Register />} />
                {/* <Route path="/l-etude" element={<Presentation />} />
                <Route path="/notre-savoir-faire" element={<Expertises />} />
                <Route path="/nous-contacter" element={<Meet />} />
                <Route path="/nous-rejoindre" element={<Join />} />
                <Route path="/nos-equipes/:ville?" element={<Notaires />} />
                <Route path="/mentions-legales" element={<MentionsLegales />} />
                <Route path="/annonces-immobilieres" element={<Annonces />} />
                <Route path="*" element={<Error />} /> */}
            </Routes>
        </div>
    );
}

export default App;
